import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Handler, HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {IconButton} from '../../../../../libs/shared/ui/src/components/buttons/iconButton';
import {PopoverCoordinator} from '../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {UserThemeConsumer} from '../../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {ChannelTypesEnum} from '../../../../models/api/channelCommonTypes';
import {ChannelTypesDropdown} from '../../../common/dropdowns/channelTypes/channelTypesDropdown';

/*
 * Props.
 */

interface ContactCardFooterComposeMessageActionProps {
  sortedChannelTypes: ReadonlyArray<ChannelTypesEnum>;
  onComposeMessage: HandlerOf<ChannelTypesEnum>;
}

/*
 * Component.
 */

export const ContactCardFooterComposeMessageAction: FC<ContactCardFooterComposeMessageActionProps> = (
  props,
) => {
  const {sortedChannelTypes, onComposeMessage} = props;

  // If we do not have any channels available, do not render the button.
  if (sortedChannelTypes.length === 0) {
    return null;
  }

  // If we only have 1 source, we can just compose when the button is clicked.
  if (sortedChannelTypes.length === 1) {
    return renderButton(undefined, () => onComposeMessage(sortedChannelTypes[0]));
  }

  return (
    <PopoverCoordinator
      renderButton={(hasHover) => renderButton(hasHover)}
      renderModal={(popoverProps) => (
        <ChannelTypesDropdown
          channelTypes={sortedChannelTypes}
          popoverProps={popoverProps}
          onSourceSelect={onComposeMessage}
        />
      )}
    />
  );
};

/*
 * Helpers.
 */

function renderButton(hasHover?: boolean, onClick?: Handler) {
  return (
    <UserThemeConsumer>
      {(theme) => (
        <IconButton
          hasHover={hasHover}
          iconName="compose"
          color={theme.greys.shade70}
          hoverColor={theme.greys.shade80}
          placement="top"
          onClick={onClick}
          label={<Trans id="contact-card-footer-action-compose-message">New message</Trans>}
        />
      )}
    </UserThemeConsumer>
  );
}
